export default "__VITE_ASSET__B2BDcpa8__"